module.exports = __webpack_public_path__ + "img/perfil_aluminio.ca8def47.jpg";